import { get, put } from '@client/lib/request';

export async function getFlashMessages(clientId, serverContext) {
    if (global.__SERVER__) {
        const { createFlashMessengerApi } = require('../../../server/lib/flashmessenger/services');
        const serverApi = createFlashMessengerApi(
            serverContext.state,
            serverContext.logger,
            serverContext.request,
            serverContext.state.config
        );
        const response = await serverApi.getMessages(clientId);
        if (response && Object.keys(response).length) {
            serverApi.deleteMessages(clientId);
        }

        return response;
    }

    return get('/mylounge-api/flashmessages');
}

export function createFlashMessage(message) {

    return put('/mylounge-api/flashmessage', message);
}
